import { NgModule } from '@angular/core';
import { AUI_IMPORTS } from './aui.imports';


@NgModule({
	imports: [
		...AUI_IMPORTS,
	],
	exports: [
		...AUI_IMPORTS,
	],
})
export class AuiModule {

}
